import React from "react";

function CCTVEmergency() {
    return (
        <div>
            <h2>Emergency Procedures & Liaison with Authorities</h2>
            <p>
                CCTV operators must be prepared to respond swiftly and effectively to emergencies. This module covers how to handle critical incidents, communicate with emergency services, and support coordinated responses from the control room.
            </p>

            <h3>Types of Emergencies</h3>
            <ul>
                <li>Fire or smoke detection</li>
                <li>Medical emergencies (e.g. collapse, injury)</li>
                <li>Security breaches or intrusions</li>
                <li>Suspicious packages or bomb threats</li>
                <li>Public disorder or violence</li>
            </ul>

            <h3>Emergency Procedures</h3>
            <ul>
                <li>Follow the site’s Emergency Action Plan (EAP)</li>
                <li>Alert on-site security and emergency services immediately</li>
                <li>Monitor and record the incident in real time</li>
                <li>Assist with evacuation coordination if required</li>
                <li>Preserve footage and logs for investigation</li>
            </ul>

            <h3>Liaising with Emergency Services</h3>
            <ul>
                <li>Provide clear, concise information (location, nature of incident, number of people involved)</li>
                <li>Maintain communication until responders arrive</li>
                <li>Grant access to relevant footage and logs</li>
                <li>Support police, fire, or medical teams as needed</li>
            </ul>

            <h3>Control Room Responsibilities</h3>
            <ul>
                <li>Stay calm and focused under pressure</li>
                <li>Coordinate with other operators and site staff</li>
                <li>Ensure all actions are logged accurately</li>
                <li>Secure the control room and restrict access</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> You observe smoke rising from a stairwell on camera. What are your immediate actions, and how do you support the emergency response?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.hse.gov.uk/toolbox/managing/emergency.htm" target="_blank" rel="noreferrer">HSE – Emergency Procedures</a></li>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Emergency Response Training</a></li>
            </ul>
        </div>
    );
}

export default CCTVEmergency;
